/**
 * Common query keys used throughout the application
 */
export const QUERY_KEYS = {
    // Main data categories
    TRANSACTIONS: 'transactions',
    TAX_REPORTS: 'taxReports',
    INTEGRATIONS: 'integrationsOverview',
    INTEGRATIONS_TOKEN_ALLOCATION: 'integrationsTokenAllocation',
    RECALCULATION: 'recalculateInfo',
    REFRESH_BALANCE: 'refreshBalance',
    USER_NOTIFICATIONS: 'userNotifications',

    // Dashboard specific keys
    DASHBOARD_BALANCE_DATA: 'dashboardBalanceData',
    DASHBOARD_PORTFOLIO_VALUE_HISTORY: 'dashboardPortfolioValueHistory',
    DASHBOARD_TOTAL_PROCEEDS: 'dashboardTotalProceeds',
    DASHBOARD_FIAT_INVESTED: 'dashboardFiatInvested',
    DASHBOARD_UNREALIZED_GAINS: 'dashboardUnrealizedGains',
    DASHBOARD_BALANCE_HISTORY: 'dashboardBalanceHistory',
    DASHBOARD_COIN_BALANCE: 'coinBalance',

    // Admin specific keys
    ADMIN_USERS: 'adminUsers',
    ADMIN_USER_PLANS: 'adminUserPlans',
    ADMIN_USER_LOGS: 'adminUserLogs',
    ADMIN_INDIVIDUAL_PLAN: 'adminIndividualPlan',
    // Helper function to invalidate all main data queries
    dataQueries: () => [
        QUERY_KEYS.TAX_REPORTS,
        QUERY_KEYS.INTEGRATIONS,
        QUERY_KEYS.INTEGRATIONS_TOKEN_ALLOCATION,
        QUERY_KEYS.USER_NOTIFICATIONS,
        // Dashboard specific keys
        QUERY_KEYS.DASHBOARD_BALANCE_DATA,
        QUERY_KEYS.DASHBOARD_PORTFOLIO_VALUE_HISTORY,
        QUERY_KEYS.DASHBOARD_TOTAL_PROCEEDS,
        QUERY_KEYS.DASHBOARD_FIAT_INVESTED,
        QUERY_KEYS.DASHBOARD_UNREALIZED_GAINS,
        QUERY_KEYS.DASHBOARD_BALANCE_HISTORY,
        QUERY_KEYS.DASHBOARD_COIN_BALANCE,
    ],
    dataQueriesWithTransactions: () => [...QUERY_KEYS.dataQueries(), QUERY_KEYS.TRANSACTIONS],
};
